var _defs, _style, _use;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDrag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 17 26",
    width: 17,
    height: 26,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "New Project") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("image", {
    width: 17,
    height: 26,
    id: "img1",
    href: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAAaBAMAAACjhKoKAAAAAXNSR0IB2cksfwAAADBQTFRFAAAAEABQDQZJDgdHDgdIDgZIDgZIEAVKDQdIEAhIDwdIDgdIDghIDgdJDgdIDgdH50SysQAAABB0Uk5TABBQ7/+foDDQQMDwgJDgjyfP0ZsAAAA5SURBVHicY2AQYIACZVcQyeZcwNDiUgBkTXFZAGWVAFnVPiBZXr8ChqEDlP1BJC4fzfYFyfJ6FwAAxr8QH836bc8AAAAASUVORK5CYII="
  }))), _style || (_style = /*#__PURE__*/React.createElement("style", null)), _use || (_use = /*#__PURE__*/React.createElement("use", {
    id: "Layer 1",
    href: "#img1",
    x: 0,
    y: 0
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDrag);
export default __webpack_public_path__ + "static/media/Icon-drag.3cd5cca114f0b345975f4f8c900dbf50.svg";
export { ForwardRef as ReactComponent };